/* ============================================
   product-custom-script.js
   Upload to: Assets/product-custom-script.js
   Dawn Theme — Custom Product Page
   Performance Optimized + Accessible
   ============================================ */

/* ⚠️  DEBUG MODE WARNING ⚠️
   Set DEBUG_VARIANT_MATCH = false before production!
   Search for "DEBUG_VARIANT_MATCH" below and change to false.
   This outputs extensive console logs for variant matching.
   ============================================ */

(function() {
  'use strict';

  /* UTILITY: Debounce for performance */
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /* UTILITY: Throttle for performance */
  function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }

  /* UTILITY: Focus trap for modals */
  function trapFocus(element) {
    const focusableElements = element.querySelectorAll(
      'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    element.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    });
  }

  /* UTILITY: Announce to screen readers */
  function announceToScreenReader(message) {
    const announcer = document.createElement('div');
    announcer.setAttribute('role', 'status');
    announcer.setAttribute('aria-live', 'polite');
    announcer.setAttribute('aria-atomic', 'true');
    announcer.className = 'sr-only';
    announcer.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;';
    announcer.textContent = message;
    document.body.appendChild(announcer);
    setTimeout(() => announcer.remove(), 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* CACHE DOM ELEMENTS - Single query for performance */
    const elements = {
      mainImg: document.getElementById('cps-main-img'),
      thumbs: document.querySelectorAll('.cps-thumb'),
      thumbNext: document.getElementById('cps-thumb-next'),
      zoomBtn: document.getElementById('cps-zoom-btn'),
      zoomModal: document.getElementById('cps-zoom-modal'),
      zoomImg: document.getElementById('cps-zoom-img'),
      sizeBtns: document.querySelectorAll('.cps-size-btn'),
      variantSelect: document.getElementById('cps-variant-select'),
      formVariantId: document.getElementById('cps-form-variant-id'),
      priceNow: document.getElementById('cps-price-now'),
      priceWas: document.getElementById('cps-price-was'),
      badgeOff: document.getElementById('cps-badge-off'),
      btnPrice: document.getElementById('cps-btn-price'),
      btnPriceCompare: document.getElementById('cps-btn-compare'),
      customOptionProp: document.getElementById('prop-custom-option'),
      videoThumb: document.getElementById('cps-video-thumb'),
      videoModal: document.getElementById('cps-video-modal'),
      videoPlayer: document.getElementById('cps-video-player'),
      wishlistBtn: document.querySelector('.cps-wishlist-btn'),
      addToCartBtn: document.getElementById('cps-btn-cart'),
      buyNowBtn: document.getElementById('cps-btn-buy'),
      validationMessage: document.getElementById('cps-validation-message')
    };

    /* BUNDLE MODE DETECTION */
    const bundleList = document.querySelector('.cps-bundle-list');
    const bundleCount = bundleList ? (parseInt(bundleList.dataset.bundleCount, 10) || 1) : 1;
    const isBundleMode = bundleCount > 1;

    /* VARIANT LOOKUP for price-based matching */
    const addonParentEl = document.querySelector('.cps-bundle-list, .cps-addon-list');
    const inlineVariantsJson = addonParentEl && addonParentEl.dataset.variants ? addonParentEl.dataset.variants : '[]';
    const productHandle = addonParentEl ? addonParentEl.dataset.productHandle : '';
    const hasMoreVariants = addonParentEl ? addonParentEl.dataset.hasMoreVariants === 'true' : false;
    let allVariants = [];
    let variantLookup = {}; // priceInCents -> array of variants
    let selectedOptions = { option1: '', option2: '', option3: '' };

    // DEBUG MODE - Set to false before production
    const DEBUG_VARIANT_MATCH = false;

    /* JERSEY BADGE VISIBILITY */
    function updateJerseyBadge(card) {
      const badge = card ? card.querySelector('.cps-jersey-badge') : null;
      if (!badge) return;

      const toggle = card.querySelector('.cps-toggle');
      const isToggleOn = toggle ? toggle.classList.contains('on') : false;
      const selectedRadio = card.querySelector('input[type="radio"][name^="cps-jersey-version-choice"]:checked');
      const selectedValue = selectedRadio ? selectedRadio.value : '';
      const standardLabel = badge.dataset.standardLabel || '';

      // Show badge when:
      // - Toggle is OFF, OR
      // - Toggle is ON and Player Version (non-standard) is selected
      // Hide badge when:
      // - Toggle is ON and Fan Version (standard) is selected
      if (!isToggleOn || (isToggleOn && selectedValue !== standardLabel)) {
        badge.classList.remove('is-hidden');
      } else {
        badge.classList.add('is-hidden');
      }
    }

    /* URGENCY NUMBER GENERATION */
    function generateUrgencyNumber() {
      // Get product ID from the page
      const productIdEl = document.querySelector('[data-product-id]');
      const productId = productIdEl ? productIdEl.dataset.productId : '';
      
      if (!productId) return 'Under limit';
      
      // Extract last two digits
      const lastTwoDigits = parseInt(productId.toString().slice(-2), 10);
      
      // Map to range 8-19
      // If lastTwoDigits is 0-99, we map it to 8-19 (12 possible values)
      const min = 8;
      const max = 19;
      const range = max - min + 1;
      const mappedNumber = (lastTwoDigits % range) + min;
      
      return mappedNumber;
    }

    // Update urgency remaining text on page load
    function updateUrgencyNumber() {
      const urgencyRemaining = document.querySelector('.cps-urgency-remaining');
      if (urgencyRemaining) {
        const number = generateUrgencyNumber();
        const text = urgencyRemaining.textContent;
        // Replace any number in the text with the generated one
        urgencyRemaining.textContent = text.replace(/\d+/, number);
      }
    }

    try {
      allVariants = JSON.parse(inlineVariantsJson);
      if (DEBUG_VARIANT_MATCH) {
        console.log('[DEBUG] Loaded ' + allVariants.length + ' variants from inline JSON');
        console.log('[DEBUG] Sample variant:', allVariants[0]);
      }
    } catch (_) {
      allVariants = [];
      if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] Failed to parse inline variants');
    }

    function buildVariantLookup() {
      variantLookup = {};
      if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] Building variant lookup table...');

      allVariants.forEach(function (v) {
        if (DEBUG_VARIANT_MATCH) {
          console.log('[DEBUG] Variant ID:', v.id, '| Price (cents):', v.price, '| Title:', v.title);
          console.log('[DEBUG]   Options:', { opt1: v.option1, opt2: v.option2, opt3: v.option3 });
        }
        if (!variantLookup[v.price]) {
          variantLookup[v.price] = [];
        }
        variantLookup[v.price].push(v);
      });

      if (DEBUG_VARIANT_MATCH) {
        console.log('[DEBUG] Variant Lookup Table Keys (price in cents):');
        Object.keys(variantLookup).forEach(function(key) {
          console.log('[DEBUG]   Key:', key, '| Variants at this price:', variantLookup[key].length);
          variantLookup[key].forEach(function(v) {
            console.log('[DEBUG]     -> ID:', v.id, '|', v.title);
          });
        });
      }
    }

    function getCurrentSelectedOptions() {
      if (elements.variantSelect) {
        const opt = elements.variantSelect.querySelector('option[value="' + elements.variantSelect.value + '"]');
        if (opt) {
          selectedOptions.option1 = opt.dataset.option1 || '';
          selectedOptions.option2 = opt.dataset.option2 || '';
          selectedOptions.option3 = opt.dataset.option3 || '';

          if (DEBUG_VARIANT_MATCH) {
            console.log('[DEBUG] Selected options from dropdown:');
            console.log('[DEBUG]   option1:', JSON.stringify(selectedOptions.option1), '| length:', selectedOptions.option1.length);
            console.log('[DEBUG]   option2:', JSON.stringify(selectedOptions.option2), '| length:', selectedOptions.option2.length);
            console.log('[DEBUG]   option3:', JSON.stringify(selectedOptions.option3), '| length:', selectedOptions.option3.length);
          }
        } else {
          if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] No option found for variantSelect value:', elements.variantSelect.value);
        }
      } else {
        if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] No variantSelect element found');
      }
    }

    function matchVariantByPrice(targetPriceCents) {
      if (DEBUG_VARIANT_MATCH) {
        console.log('[DEBUG] ============================================');
        console.log('[DEBUG] matchVariantByPrice called');
        console.log('[DEBUG] Target price (cents):', targetPriceCents, '| (dollars):', (targetPriceCents / 100).toFixed(10));
        console.log('[DEBUG] Available lookup keys:', Object.keys(variantLookup));
      }

      const candidates = variantLookup[targetPriceCents];

      if (!candidates || candidates.length === 0) {
        if (DEBUG_VARIANT_MATCH) {
          console.log('[DEBUG] ❌ NO MATCH: No candidates for price key:', targetPriceCents);
          console.log('[DEBUG]    Checking for floating point issues...');
          // Check nearby keys
          Object.keys(variantLookup).forEach(function(key) {
            const keyNum = parseInt(key, 10);
            const diff = Math.abs(keyNum - targetPriceCents);
            if (diff <= 5) {
              console.log('[DEBUG]    Nearby key found:', key, '(diff:', diff, 'cents)');
            }
          });
        }
        return null;
      }

      if (DEBUG_VARIANT_MATCH) {
        console.log('[DEBUG] ✅ FOUND:', candidates.length, 'candidate(s) at price', targetPriceCents);
        candidates.forEach(function(c, i) {
          console.log('[DEBUG]   Candidate', i + 1, ': ID=' + c.id, '| Title=' + c.title);
          console.log('[DEBUG]     Options:', { opt1: c.option1, opt2: c.option2, opt3: c.option3 });
        });
      }

      if (candidates.length === 1) {
        if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] Only 1 candidate - returning it');
        return candidates[0];
      }

      getCurrentSelectedOptions();

      if (DEBUG_VARIANT_MATCH) {
        console.log('[DEBUG] Multiple candidates - checking option matching...');
        console.log('[DEBUG] Current selected options:', selectedOptions);
      }

      for (let i = 0; i < candidates.length; i++) {
        const v = candidates[i];
        if (DEBUG_VARIANT_MATCH) {
          console.log('[DEBUG] Comparing candidate', i + 1, ':', v.title);
          console.log('[DEBUG]   Candidate opts:', { opt1: v.option1, opt2: v.option2, opt3: v.option3 });
          console.log('[DEBUG]   Match checks:');
          console.log('[DEBUG]     opt1:', v.option1, '===', selectedOptions.option1, '?', v.option1 === selectedOptions.option1);
          console.log('[DEBUG]     opt2:', v.option2, '===', selectedOptions.option2, '?', v.option2 === selectedOptions.option2);
          console.log('[DEBUG]     opt3:', v.option3, '===', selectedOptions.option3, '?', v.option3 === selectedOptions.option3);
        }

        if ((v.option1 === selectedOptions.option1 || !selectedOptions.option1) &&
            (v.option2 === selectedOptions.option2 || !selectedOptions.option2) &&
            (v.option3 === selectedOptions.option3 || !selectedOptions.option3)) {
          if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] ✅ MATCHED candidate', i + 1);
          return v;
        }
      }

      if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] No option match - returning first candidate');
      return candidates[0];
    }

    function updateFormVariant(variant) {
      if (!variant || !elements.formVariantId) return;
      elements.formVariantId.value = variant.id;
      if (elements.variantSelect) {
        elements.variantSelect.value = variant.id;
      }
    }

    buildVariantLookup();
    getCurrentSelectedOptions();
    updateUrgencyNumber();

    // Initialize jersey badge visibility for all cards
    document.querySelectorAll('.cps-addon-expandable[data-addon="jersey-version"]').forEach(function(card) {
      updateJerseyBadge(card);
    });

    if (hasMoreVariants && productHandle) {
      fetch('/products/' + encodeURIComponent(productHandle) + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.variants) {
            allVariants = data.variants.map(function (v) {
              return {
                id: v.id,
                title: v.title || '',
                price: Math.round((parseFloat(v.price) || 0) * 100),
                option1: v.option1 || '',
                option2: v.option2 || '',
                option3: v.option3 || ''
              };
            });
            buildVariantLookup();
          }
        })
        .catch(function () {
          /* Silent fail — inline variants remain */
        });
    }

    /* IMAGE GALLERY */
    let thumbOffset = 0;
    const VISIBLE = 5;

    if (elements.thumbs.length > VISIBLE) {
      elements.thumbs.forEach(function (t, i) {
        t.style.display = i < VISIBLE ? '' : 'none';
      });
    }

    elements.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        elements.thumbs.forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');

        if (elements.mainImg) {
          elements.mainImg.src = thumb.dataset.full;
          elements.mainImg.alt = thumb.alt || '';
        }
      });
    });

    if (elements.thumbNext && elements.thumbs.length > VISIBLE) {
      elements.thumbNext.addEventListener('click', function () {
        thumbOffset = (thumbOffset + 1) % elements.thumbs.length;

        elements.thumbs.forEach(function (t, i) {
          const visible = i >= thumbOffset && i < thumbOffset + VISIBLE;
          t.style.display = visible ? '' : 'none';
        });

        if (thumbOffset + VISIBLE > elements.thumbs.length) {
          const overflowCount = (thumbOffset + VISIBLE) - elements.thumbs.length;
          for (let i = 0; i < overflowCount; i += 1) {
            elements.thumbs[i].style.display = '';
          }
        }
      });
    }

    /* ZOOM MODAL with accessibility */
    if (elements.zoomBtn && elements.mainImg && elements.zoomModal && elements.zoomImg) {
      elements.zoomBtn.addEventListener('click', function () {
        elements.zoomImg.src = elements.mainImg.src;
        elements.zoomImg.alt = elements.mainImg.alt || 'Zoomed product image';
        elements.zoomModal.classList.add('open');
        elements.zoomModal.setAttribute('aria-hidden', 'false');
        elements.zoomModal.focus();
        trapFocus(elements.zoomModal);
        document.body.style.overflow = 'hidden';
      });
    }

    if (elements.zoomModal) {
      elements.zoomModal.addEventListener('click', function (e) {
        if (e.target === elements.zoomModal || e.target === elements.zoomImg) {
          closeZoomModal();
        }
      });

      elements.zoomModal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeZoomModal();
        }
      });
    }

    function closeZoomModal() {
      if (elements.zoomModal) {
        elements.zoomModal.classList.remove('open');
        elements.zoomModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (elements.zoomBtn) elements.zoomBtn.focus();
      }
    }

    /* SIZE CHART - Scroll to Tab Section */
    function scrollToSizeChartTab() {
      // Find the Size Chart tab button
      const sizeChartTabBtn = document.querySelector('.cps-tab-btn[onclick*="cpsTab(this,\'size\')"]') ||
                              document.querySelector('.cps-tab-btn[onclick*="cpsTab(this,\x27size\x27)"]');

      if (sizeChartTabBtn) {
        // Activate the size chart tab
        window.cpsTab(sizeChartTabBtn, 'size');
      }

      // Scroll to the tabs section
      const tabsSection = document.querySelector('.cps-tabs-section');
      if (tabsSection) {
        tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    // Handle all size chart buttons (single mode and bundle mode)
    const sizeChartButtons = document.querySelectorAll('.cps-size-chart-btn');
    sizeChartButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        scrollToSizeChartTab();
      });
    });

    /* SIZE SELECTOR + VARIANT */
    /* Read addon prices from data attributes for block-based configuration */
    const nameNumberCard = document.getElementById('cps-addon-name-number-card');
    const jerseyVersionCard = document.getElementById('cps-addon-jersey-version-card');
    const patchesCard = document.getElementById('cps-addon-patches-card');
    const longSleeveCard = document.getElementById('cps-addon-long-sleeve-card');

    const ADDON_AMOUNTS = {
      nameNumber: nameNumberCard ? (parseFloat(nameNumberCard.dataset.price) || 3.99) : 0,
      playerVersion: jerseyVersionCard ? (parseFloat(jerseyVersionCard.dataset.price) || 4.99) : 0,
      patches: patchesCard ? (parseFloat(patchesCard.dataset.price) || 2.99) : 0,
      longSleeve: longSleeveCard ? (parseFloat(longSleeveCard.dataset.price) || 6.99) : 0
    };

    if (DEBUG_VARIANT_MATCH) {
      console.log('[DEBUG] === ADDON_AMOUNTS initialized ===');
      console.log('[DEBUG] nameNumberCard dataset.price:', nameNumberCard ? nameNumberCard.dataset.price : 'NO CARD');
      console.log('[DEBUG] nameNumber parseFloat result:', nameNumberCard ? parseFloat(nameNumberCard.dataset.price) : 'N/A', '-> ADDON_AMOUNTS.nameNumber:', ADDON_AMOUNTS.nameNumber);
      console.log('[DEBUG] jerseyVersionCard dataset.price:', jerseyVersionCard ? jerseyVersionCard.dataset.price : 'NO CARD');
      console.log('[DEBUG] playerVersion parseFloat result:', jerseyVersionCard ? parseFloat(jerseyVersionCard.dataset.price) : 'N/A', '-> ADDON_AMOUNTS.playerVersion:', ADDON_AMOUNTS.playerVersion);
      console.log('[DEBUG] patchesCard dataset.price:', patchesCard ? patchesCard.dataset.price : 'NO CARD');
      console.log('[DEBUG] patches parseFloat result:', patchesCard ? parseFloat(patchesCard.dataset.price) : 'N/A', '-> ADDON_AMOUNTS.patches:', ADDON_AMOUNTS.patches);
      console.log('[DEBUG] longSleeveCard dataset.price:', longSleeveCard ? longSleeveCard.dataset.price : 'NO CARD');
      console.log('[DEBUG] longSleeve parseFloat result:', longSleeveCard ? parseFloat(longSleeveCard.dataset.price) : 'N/A', '-> ADDON_AMOUNTS.longSleeve:', ADDON_AMOUNTS.longSleeve);
    }

    /* Create default state object */
    function createDefaultState() {
      return {
        nameNumber: true,
        playerVersionEnabled: false,
        playerVersionChoice: 'Player Version Jersey',
        patchesEnabled: false,
        selectedPatch: '',
        longSleeve: false,
        size: ''
      };
    }

    /* Bundle mode: array of states. Single mode: single state object */
    const addonStates = isBundleMode
      ? Array.from({ length: bundleCount }, createDefaultState)
      : [createDefaultState()];

    /* Helper to get state by index (0-based) */
    function getState(index) {
      return addonStates[index] || addonStates[0];
    }

    let currentBasePriceText = elements.priceNow ? elements.priceNow.textContent :
                               elements.btnPrice ? elements.btnPrice.textContent :
                               '$39.99';

    let currentBaseCompareText = elements.btnPriceCompare ? elements.btnPriceCompare.textContent : '';

    function updateDiscount(priceText, compareText) {
      if (!elements.badgeOff || !priceText || !compareText) return;

      const price = Number(String(priceText).replace(/[^0-9.]/g, ''));
      const compare = Number(String(compareText).replace(/[^0-9.]/g, ''));

      if (compare > price && compare > 0) {
        const pct = Math.round(((compare - price) / compare) * 100);
        elements.badgeOff.textContent = pct + '% OFF';
        elements.badgeOff.style.display = 'inline-flex';
      } else {
        elements.badgeOff.style.display = 'none';
      }
    }

    function parseMoneyValue(text) {
      const number = Number(String(text || '').replace(/[^0-9.]/g, ''));
      return isNaN(number) ? 0 : number;
    }

    function formatMoneyLike(templateText, amount) {
      const text = String(templateText || '$0.00');
      const match = text.match(/[^0-9.,]*[0-9,.]+[^0-9.,]*/);

      if (!match) {
        return '$' + amount.toFixed(2);
      }

      const numberPart = match[0];
      const prefixMatch = numberPart.match(/^[^0-9]*/);
      const suffixMatch = numberPart.match(/[^0-9]*$/);

      const prefix = prefixMatch ? prefixMatch[0] : '';
      const suffix = suffixMatch ? suffixMatch[0] : '';

      return prefix + amount.toFixed(2) + suffix;
    }

    function getAddonTotalForState(state) {
      let total = 0;
      const breakdown = [];

      if (state.nameNumber) {
        total += ADDON_AMOUNTS.nameNumber;
        breakdown.push('nameNumber: +' + ADDON_AMOUNTS.nameNumber);
      }

      if (state.playerVersionEnabled && state.playerVersionChoice === 'Player Version Jersey') {
        total += ADDON_AMOUNTS.playerVersion;
        breakdown.push('playerVersion: +' + ADDON_AMOUNTS.playerVersion);
      }

      if (state.patchesEnabled) {
        total += ADDON_AMOUNTS.patches;
        breakdown.push('patches: +' + ADDON_AMOUNTS.patches);
      }

      if (state.longSleeve) {
        total += ADDON_AMOUNTS.longSleeve;
        breakdown.push('longSleeve: +' + ADDON_AMOUNTS.longSleeve);
      }

      if (DEBUG_VARIANT_MATCH && breakdown.length > 0) {
        console.log('[DEBUG] getAddonTotalForState breakdown:', breakdown.join(', '), '| total:', total);
      }

      return total;
    }

    function getAddonTotal() {
      let total = 0;
      if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] getAddonTotal() for', addonStates.length, 'state(s)');
      addonStates.forEach(function (state, i) {
        const stateTotal = getAddonTotalForState(state);
        if (DEBUG_VARIANT_MATCH) console.log('[DEBUG]   State', i, 'total:', stateTotal, '| state:', JSON.stringify(state));
        total += stateTotal;
      });
      if (DEBUG_VARIANT_MATCH) console.log('[DEBUG] getAddonTotal() FINAL:', total);
      return total;
    }

    let currentMatchedVariant = null;
    let lastCalculatedPriceCents = 0;

    function refreshDisplayedTotal() {
      const baseValue = parseMoneyValue(currentBasePriceText);
      /* Bundle product price already reflects the pack cost; only addons stack */
      const addonTotal = getAddonTotal();
      const finalValue = baseValue + addonTotal;
      const formatted = formatMoneyLike(currentBasePriceText, finalValue);

      if (DEBUG_VARIANT_MATCH) {
        console.log('[DEBUG] ============================================');
        console.log('[DEBUG] refreshDisplayedTotal()');
        console.log('[DEBUG] Base value:', baseValue, '(dollars)');
        console.log('[DEBUG] Addon total:', addonTotal, '(dollars)');
        console.log('[DEBUG] FINAL VALUE:', finalValue, '(dollars, full precision)');
        console.log('[DEBUG] Raw finalValue:', finalValue.toString());
      }

      if (elements.btnPrice) {
        elements.btnPrice.textContent = formatted;
      }

      // Update compare at price on button if it exists
      if (elements.btnPriceCompare && currentBaseCompareText) {
        const baseCompareValue = parseMoneyValue(currentBaseCompareText);
        const finalCompareValue = baseCompareValue + addonTotal;
        const formattedCompare = formatMoneyLike(currentBaseCompareText, finalCompareValue);
        elements.btnPriceCompare.textContent = formattedCompare;
        elements.btnPriceCompare.style.display = 'inline';
      } else if (elements.btnPriceCompare) {
        elements.btnPriceCompare.style.display = 'none';
      }

      /* Match variant by total price and update form */
      const targetCents = Math.round(finalValue * 100);
      lastCalculatedPriceCents = targetCents;

      if (DEBUG_VARIANT_MATCH) {
        console.log('[DEBUG] Target cents (Math.round):', targetCents);
        console.log('[DEBUG] Without Math.round:', (finalValue * 100), '(may show floating point issues)');
      }

      const matchedVariant = matchVariantByPrice(targetCents);

      if (matchedVariant) {
        currentMatchedVariant = matchedVariant;
        updateFormVariant(matchedVariant);
        clearVariantMatchError();
      } else {
        currentMatchedVariant = null;
        showVariantMatchError(targetCents, finalValue);
      }
    }

    function showVariantMatchError(cents, dollars) {
      const formattedPrice = formatMoneyLike(currentBasePriceText, dollars);
      const errorMsg = 'Configuration error: No product variant exists for price ' + formattedPrice + '. Please adjust your selections.';

      if (DEBUG_VARIANT_MATCH) {
        console.log('[DEBUG] ❌❌❌ showVariantMatchError called');
        console.log('[DEBUG] Failed price (cents):', cents, '| (dollars):', dollars.toString());
        console.log('[DEBUG] ALL available lookup keys:', Object.keys(variantLookup));
        console.log('[DEBUG] All available prices (dollars):');
        Object.keys(variantLookup).forEach(function(key) {
          console.log('[DEBUG]   Key:', key, '=> $' + (parseInt(key, 10) / 100).toFixed(2));
        });
      }

      // Show in validation box (CSS handles the styling)
      if (elements.validationMessage) {
        elements.validationMessage.innerHTML = '<div class="cps-config-error">' + errorMsg + '</div>';
        elements.validationMessage.classList.add('visible');
        elements.validationMessage.style.display = 'block';
      }

      // CSS classes handle visual disabled state
      if (elements.addToCartBtn) {
        elements.addToCartBtn.disabled = true;
        elements.addToCartBtn.classList.add('cps-btn-disabled');
      }
      if (elements.buyNowBtn) {
        elements.buyNowBtn.disabled = true;
        elements.buyNowBtn.classList.add('cps-btn-disabled');
      }

      // Add visual error state to price display
      if (elements.btnPrice) {
        elements.btnPrice.classList.add('cps-price-error');
        elements.btnPrice.textContent = formattedPrice + ' (Invalid)';
      }
    }

    function clearVariantMatchError() {
      // Clear validation message if it was a variant error
      if (elements.validationMessage) {
        const msg = elements.validationMessage.innerHTML;
        if (msg && msg.includes('Configuration error')) {
          elements.validationMessage.textContent = '';
          elements.validationMessage.classList.remove('visible');
          elements.validationMessage.style.display = 'none';
        }
      }

      // Remove disabled CSS classes
      if (elements.addToCartBtn) {
        elements.addToCartBtn.classList.remove('cps-btn-disabled');
      }
      if (elements.buyNowBtn) {
        elements.buyNowBtn.classList.remove('cps-btn-disabled');
      }

      // Clear price error styling
      if (elements.btnPrice) {
        elements.btnPrice.classList.remove('cps-price-error');
      }

      // Re-validate to update button states properly
      validateAddonFields();
    }

    function hasValidVariantMatch() {
      return currentMatchedVariant !== null && currentMatchedVariant !== undefined;
    }

    /* VALIDATION for required addon fields */
    function validateAddonFields() {
      const errors = [];
      let hasErrors = false;

      function clearErrorsInCard(card) {
        if (!card) return;
        const inputs = card.querySelectorAll('.cps-addon-input, .cps-addon-select');
        inputs.forEach(function (input) {
          input.classList.remove('error');
          input.removeAttribute('aria-invalid');
        });
      }

      function markInputError(input) {
        if (!input) return;
        input.classList.add('error');
        input.setAttribute('aria-invalid', 'true');
      }

      if (isBundleMode) {
        const panels = document.querySelectorAll('.cps-bundle-panel');
        panels.forEach(function (panel, index) {
          const state = getState(index);
          const bundleLabel = bundleList ? (bundleList.dataset.bundleLabel || 'Item') : 'Item';
          const prefix = bundleLabel + ' ' + (index + 1);

          const nnCard = panel.querySelector('[data-addon="name-number"]');
          if (nnCard && state.nameNumber) {
            clearErrorsInCard(nnCard);
            const nameInput = nnCard.querySelector('input[id^="cps-player-name"]');
            const numInput = nnCard.querySelector('input[id^="cps-player-number"]');

            if (!nameInput || !nameInput.value.trim()) {
              hasErrors = true;
              markInputError(nameInput);
              errors.push(prefix + ': Player name is required');
            }
            if (!numInput || !numInput.value.trim()) {
              hasErrors = true;
              markInputError(numInput);
              errors.push(prefix + ': Player number is required');
            }
          }

          const patchCard = panel.querySelector('[data-addon="worldcup-patch"]');
          if (patchCard && state.patchesEnabled) {
            clearErrorsInCard(patchCard);
            const select = patchCard.querySelector('select');

            if (!select || !select.value.trim()) {
              hasErrors = true;
              markInputError(select);
              errors.push(prefix + ': Please select a patch');
            }
          }
        });
      } else {
        const state = getState(0);

        const nnCard = document.getElementById('cps-addon-name-number-card');
        if (nnCard && state.nameNumber) {
          clearErrorsInCard(nnCard);
          if (playerNameInput && !playerNameInput.value.trim()) {
            hasErrors = true;
            markInputError(playerNameInput);
            errors.push('Player name is required');
          }
          if (playerNumberInput && !playerNumberInput.value.trim()) {
            hasErrors = true;
            markInputError(playerNumberInput);
            errors.push('Player number is required');
          }
        }

        const patchCard = document.getElementById('cps-addon-patches-card');
        if (patchCard && state.patchesEnabled) {
          clearErrorsInCard(patchCard);
          if (patchSelect && !patchSelect.value.trim()) {
            hasErrors = true;
            markInputError(patchSelect);
            errors.push('Please select a patch');
          }
        }
      }

      // CRITICAL: Check if we have a valid variant match
      if (!hasValidVariantMatch()) {
        hasErrors = true;
        const formattedPrice = formatMoneyLike(currentBasePriceText, lastCalculatedPriceCents / 100);
        errors.push('No product variant exists for price ' + formattedPrice + '. Please adjust your selections.');
      }

      updateValidationUI(hasErrors, errors);
      return !hasErrors;
    }

    function updateValidationUI(hasErrors, errors) {
      if (elements.validationMessage) {
        if (hasErrors && errors.length > 0) {
          elements.validationMessage.innerHTML = errors.map(function (e) {
            return '<div>' + e + '</div>';
          }).join('');
          elements.validationMessage.classList.add('visible');
          elements.validationMessage.style.display = 'block';
        } else {
          elements.validationMessage.textContent = '';
          elements.validationMessage.classList.remove('visible');
          elements.validationMessage.style.display = 'none';
        }
      }

      // Handle button states with CSS classes for variant mismatch
      if (elements.addToCartBtn) {
        elements.addToCartBtn.disabled = hasErrors;
        if (hasErrors) {
          elements.addToCartBtn.classList.add('cps-btn-disabled');
        } else {
          elements.addToCartBtn.classList.remove('cps-btn-disabled');
        }
      }
      if (elements.buyNowBtn) {
        elements.buyNowBtn.disabled = hasErrors;
        if (hasErrors) {
          elements.buyNowBtn.classList.add('cps-btn-disabled');
        } else {
          elements.buyNowBtn.classList.remove('cps-btn-disabled');
        }
      }
    }

    function clearValidationErrors() {
      if (elements.validationMessage) {
        elements.validationMessage.textContent = '';
        elements.validationMessage.classList.remove('visible');
        elements.validationMessage.style.display = 'none';
      }
      document.querySelectorAll('.cps-addon-input.error, .cps-addon-select.error').forEach(function (el) {
        el.classList.remove('error');
        el.removeAttribute('aria-invalid');
      });
    }

    /* SIZE BUTTONS with keyboard support */
    elements.sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('unavailable')) return;

        const selectedValue = btn.dataset.value;
        const isCustomOption = btn.dataset.optionType === 'custom';
        const btnBundleIndex = btn.dataset.bundleIndex;

        announceToScreenReader('Selected size: ' + selectedValue);

        if (isCustomOption) {
          if (isBundleMode && btnBundleIndex) {
            // Update size for specific bundle
            const sizeInput = document.querySelector('.prop-custom-option-bundle[data-bundle-index="' + btnBundleIndex + '"]');
            if (sizeInput) {
              sizeInput.value = selectedValue;
            }
            // Update state
            const state = getState(parseInt(btnBundleIndex, 10) - 1);
            state.size = selectedValue;

            // Update visual active state within this bundle's buttons only
            const bundlePanel = btn.closest('.cps-bundle-panel');
            if (bundlePanel) {
              bundlePanel.querySelectorAll('.cps-size-btn').forEach(function (b) {
                b.classList.remove('active');
                b.setAttribute('aria-checked', 'false');
              });
              btn.classList.add('active');
              btn.setAttribute('aria-checked', 'true');
            }
          } else {
            // Single mode
            if (elements.customOptionProp) {
              elements.customOptionProp.value = selectedValue;
            }
            // Update single mode visual state
            document.querySelectorAll('.cps-size-buttons-single .cps-size-btn').forEach(function (b) {
              b.classList.remove('active');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('active');
            btn.setAttribute('aria-checked', 'true');
          }
          return;
        }

        // For regular size buttons (not custom options), do global clearing
        elements.sizeBtns.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });

        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');

        const optionPosition = parseInt(btn.dataset.optionPosition, 10);
        const optionKey = 'data-option' + optionPosition;

        if (elements.variantSelect) {
          const options = elements.variantSelect.querySelectorAll('option');
          let matched = null;

          options.forEach(function (opt) {
            if (opt.getAttribute(optionKey) === selectedValue && !opt.disabled && !matched) {
              matched = opt;
            }
          });

          if (matched) {
            elements.variantSelect.value = matched.value;

            if (elements.formVariantId) {
              elements.formVariantId.value = matched.value;
            }

            const price = matched.dataset.price || '';
            const compare = matched.dataset.comparePrice || '';

            if (elements.priceNow) {
              elements.priceNow.textContent = price;
              currentBasePriceText = price;
            }

            if (elements.priceWas) {
              if (compare && compare !== price) {
                elements.priceWas.textContent = compare;
                elements.priceWas.style.display = 'inline';
              } else {
                elements.priceWas.textContent = '';
                elements.priceWas.style.display = 'none';
              }
            }

            // Track base compare price for button display
            currentBaseCompareText = compare && compare !== price ? compare : '';

            updateDiscount(price, compare);
            refreshDisplayedTotal();
          }
        }
      });

      /* Keyboard accessibility for size buttons */
      btn.addEventListener('keydown', function(e) {
        const buttons = Array.from(elements.sizeBtns);
        const index = buttons.indexOf(btn);

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          const next = buttons[index + 1] || buttons[0];
          next.focus();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = buttons[index - 1] || buttons[buttons.length - 1];
          prev.focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

    /* ADDON HELPERS */
    const propNameNumber = document.getElementById('prop-name-number');
    const propPlayerName = document.getElementById('prop-player-name');
    const propPlayerNumber = document.getElementById('prop-player-number');
    const propNameNumberPrice = document.getElementById('prop-name-number-price');

    const propJerseyVersionEnabled = document.getElementById('prop-jersey-version-enabled');
    const propJerseyVersionSelection = document.getElementById('prop-jersey-version-selection');
    const propJerseyVersionPrice = document.getElementById('prop-jersey-version-price');

    const propPatchesEnabled = document.getElementById('prop-worldcup-patch');
    const propSelectedPatch = document.getElementById('prop-selected-patch');
    const propPatchesPrice = document.getElementById('prop-worldcup-patch-price');

    const propLongSleeve = document.getElementById('prop-long-sleeve');
    const propLongSleevePrice = document.getElementById('prop-long-sleeve-price');

    const playerNameInput = document.getElementById('cps-player-name');
    const playerNumberInput = document.getElementById('cps-player-number');
    const patchSelect = document.getElementById('cps-patch-select');
    const jerseyVersionRadios = document.querySelectorAll('input[name="cps-jersey-version-choice"]');

    function syncNameNumberFields() {
      if (propPlayerName && playerNameInput) {
        propPlayerName.value = addonStates[0].nameNumber ? playerNameInput.value : '';
      }

      if (propPlayerNumber && playerNumberInput) {
        propPlayerNumber.value = addonStates[0].nameNumber ? playerNumberInput.value : '';
      }
    }

    function syncJerseyVersionChoice() {
      let selected = 'Fan Version Jersey';

      jerseyVersionRadios.forEach(function (radio) {
        if (radio.checked) {
          selected = radio.value;
        }
      });

      addonStates[0].playerVersionChoice = selected;

      if (propJerseyVersionSelection) {
        propJerseyVersionSelection.value = addonStates[0].playerVersionEnabled ? selected : 'Fan Version Jersey';
      }

      if (propJerseyVersionPrice) {
        if (addonStates[0].playerVersionEnabled && selected === 'Player Version Jersey') {
          propJerseyVersionPrice.value = ADDON_AMOUNTS.playerVersion.toFixed(2);
        } else {
          propJerseyVersionPrice.value = '0';
        }
      }

      refreshDisplayedTotal();
    }

    function syncPatchSelection() {
      const selectedPatch = patchSelect ? patchSelect.value : '';

      addonStates[0].selectedPatch = selectedPatch;

      if (propSelectedPatch) {
        propSelectedPatch.value = addonStates[0].patchesEnabled ? selectedPatch : '';
      }

      if (propPatchesPrice) {
        propPatchesPrice.value = addonStates[0].patchesEnabled ? ADDON_AMOUNTS.patches.toFixed(2) : '0';
      }

      refreshDisplayedTotal();
    }

    function syncLongSleeve() {
      if (propLongSleeve) {
        propLongSleeve.value = addonStates[0].longSleeve ? 'Yes' : 'No';
      }

      if (propLongSleevePrice) {
        propLongSleevePrice.value = addonStates[0].longSleeve ? ADDON_AMOUNTS.longSleeve.toFixed(2) : '0';
      }

      refreshDisplayedTotal();
    }

    /* BUNDLE PANEL TOGGLE */
    window.cpsToggleBundlePanel = function (header) {
      const panel = header.closest('.cps-bundle-panel');
      if (!panel) return;

      const isOpen = panel.classList.contains('open');
      const newOpen = !isOpen;
      panel.classList.toggle('open', newOpen);
      header.setAttribute('aria-expanded', newOpen ? 'true' : 'false');

      const icon = header.querySelector('.cps-bundle-toggle-icon');
      if (icon) {
        icon.innerHTML = newOpen
          ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 15l-6-6-6 6"/></svg>'
          : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>';
      }

      // Focus management: move focus to first interactive element when expanded
      if (newOpen) {
        setTimeout(function() {
          const focusable = panel.querySelector('input, select, textarea, button:not(.cps-size-chart-btn), [tabindex="0"]');
          if (focusable) focusable.focus();
        }, 50);
      }
    };

    /* Parse addon name to extract base name and bundle index */
    function parseAddonName(addonName) {
      const match = addonName.match(/^(.+)-(\d+)$/);
      if (match) {
        return { baseName: match[1], index: parseInt(match[2], 10) - 1 };
      }
      return { baseName: addonName, index: 0 };
    }

    window.cpsToggle = function (el, addonName) {
      el.classList.toggle('on');

      const isOn = el.classList.contains('on');
      el.setAttribute('aria-checked', isOn ? 'true' : 'false');

      const parsed = parseAddonName(addonName);
      const baseName = parsed.baseName;
      const stateIndex = parsed.index;
      const state = getState(stateIndex);

      announceToScreenReader((isOn ? 'Enabled' : 'Disabled') + ' ' + baseName.replace(/-/g, ' '));

      const card = el.closest('.cps-addon-expandable');

      if (card) {
        card.classList.toggle('open', isOn);

        // Focus management: move focus to first interactive element when expanded
        if (isOn) {
          setTimeout(function() {
            const focusable = card.querySelector('input, select, textarea, button:not(.cps-size-chart-btn)');
            if (focusable) focusable.focus();
          }, 50);
        }
      }

      if (baseName === 'name-number') {
        state.nameNumber = isOn;

        if (!isBundleMode) {
          if (propNameNumber) {
            propNameNumber.value = isOn ? 'Yes' : 'No';
          }
          if (propNameNumberPrice) {
            propNameNumberPrice.value = isOn ? ADDON_AMOUNTS.nameNumber.toFixed(2) : '0';
          }
        }

        if (!isOn) {
          const nameInput = card ? card.querySelector('input[id^="cps-player-name"]') : null;
          const numInput = card ? card.querySelector('input[id^="cps-player-number"]') : null;
          if (nameInput) nameInput.value = '';
          if (numInput) numInput.value = '';
        }

        if (!isBundleMode) {
          syncNameNumberFields();
        }
        refreshDisplayedTotal();
      }

      if (baseName === 'jersey-version') {
        state.playerVersionEnabled = isOn;

        if (!isBundleMode && propJerseyVersionEnabled) {
          propJerseyVersionEnabled.value = isOn ? 'Yes' : 'No';
        }

        const radios = card ? card.querySelectorAll('input[type="radio"]') : [];
        if (isOn) {
          radios.forEach(function (radio) {
            if (radio.value.toLowerCase().includes('player')) {
              radio.checked = true;
              state.playerVersionChoice = radio.value;
            }
          });
        } else {
          radios.forEach(function (radio) {
            if (radio.value.toLowerCase().includes('fan')) {
              radio.checked = true;
            }
          });
          state.playerVersionChoice = 'Fan Version Jersey';
        }

        updateJerseyBadge(card);

        if (!isBundleMode) {
          syncJerseyVersionChoice();
        }
        refreshDisplayedTotal();
      }

      if (baseName === 'worldcup-patch') {
        state.patchesEnabled = isOn;

        if (!isBundleMode && propPatchesEnabled) {
          propPatchesEnabled.value = isOn ? 'Yes' : 'No';
        }

        const select = card ? card.querySelector('select') : null;
        if (isOn) {
          if (select && !select.value) {
            const firstOption = select.querySelector('option:not([value=""])');
            if (firstOption) {
              select.value = firstOption.value;
              state.selectedPatch = firstOption.value;
            }
          }
        } else {
          if (select) select.value = '';
          state.selectedPatch = '';
        }

        if (!isBundleMode) {
          syncPatchSelection();
        }
        refreshDisplayedTotal();
      }

      if (baseName === 'long-sleeve') {
        state.longSleeve = isOn;

        const longSleeveRow = card ? card.querySelector('.cps-option-card-static') : null;
        if (longSleeveRow) {
          longSleeveRow.classList.toggle('active', isOn);
        }

        if (!isBundleMode) {
          syncLongSleeve();
        }
        refreshDisplayedTotal();
      }

      validateAddonFields();
    };

    /* TABS */
    window.cpsTab = function (btn, id) {
      document.querySelectorAll('.cps-tab-btn').forEach(function (b) {
        b.classList.remove('active');
      });

      document.querySelectorAll('.cps-tab-panel').forEach(function (p) {
        p.classList.remove('active');
      });

      btn.classList.add('active');

      const panel = document.getElementById('cps-tab-' + id);
      if (panel) {
        panel.classList.add('active');
      }
    };

    /* FAQ */
    window.cpsFaq = function (el) {
      const answer = el.nextElementSibling;
      el.classList.toggle('open');

      if (answer) {
        answer.classList.toggle('open');
      }
    };

    /* WISHLIST UI ONLY - Accessible */
    if (elements.wishlistBtn) {
      let wishlisted = false;
      elements.wishlistBtn.addEventListener('click', function () {
        wishlisted = !wishlisted;
        elements.wishlistBtn.style.color = wishlisted ? '#cc0000' : '';
        elements.wishlistBtn.setAttribute('aria-pressed', wishlisted);

        const svgPath = elements.wishlistBtn.querySelector('path');
        if (svgPath) {
          svgPath.setAttribute('fill', wishlisted ? '#cc0000' : 'none');
        }
        announceToScreenReader(wishlisted ? 'Added to wishlist' : 'Removed from wishlist');
      });
    }

    /* VIDEO MODAL with accessibility */
    if (elements.videoThumb && elements.videoModal && elements.videoPlayer) {
      elements.videoThumb.addEventListener('click', function () {
        const videoUrl = elements.videoThumb.dataset.video;
        elements.videoPlayer.src = videoUrl;
        elements.videoModal.classList.add('open');
        elements.videoModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        trapFocus(elements.videoModal);

        const playPromise = elements.videoPlayer.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });

      elements.videoModal.addEventListener('click', function (e) {
        if (e.target === elements.videoModal || e.target === elements.videoPlayer) {
          closeVideoModal();
        }
      });

      elements.videoModal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeVideoModal();
        }
      });
    }

    function closeVideoModal() {
      if (elements.videoModal && elements.videoPlayer) {
        elements.videoPlayer.pause();
        elements.videoPlayer.currentTime = 0;
        elements.videoModal.classList.remove('open');
        elements.videoModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (elements.videoThumb) elements.videoThumb.focus();
      }
    }

    /* FIELD AND OPTION SYNC with debounce */
    const debouncedSyncNameNumber = debounce(syncNameNumberFields, 150);

    if (playerNameInput) {
      playerNameInput.addEventListener('input', function() {
        debouncedSyncNameNumber();
        validateAddonFields();
      });
    }

    if (playerNumberInput) {
      playerNumberInput.addEventListener('input', function() {
        debouncedSyncNameNumber();
        validateAddonFields();
      });
    }

    /* Real-time validation for bundle mode inputs - delegated */
    document.addEventListener('input', function(e) {
      const input = e.target.closest('.cps-addon-input');
      if (input) {
        validateAddonFields();
      }
    });

    /* PATCH SELECT - delegated for bundle mode */
    document.addEventListener('change', function(e) {
      const select = e.target.closest('.cps-addon-select');
      if (select) {
        const card = select.closest('.cps-addon-expandable');
        if (card && card.dataset.addon === 'worldcup-patch') {
          const panel = card.closest('.cps-bundle-panel');
          const index = panel ? (parseInt(panel.dataset.bundleIndex, 10) - 1) : 0;
          const state = getState(index);

          state.patchesEnabled = card.classList.contains('open') || card.querySelector('.cps-toggle')?.classList.contains('on');
          state.selectedPatch = select.value;

          if (!isBundleMode) {
            syncPatchSelection();
          }
          refreshDisplayedTotal();
          validateAddonFields();
        }
      }
    });

    /* JERSEY VERSION RADIOS - delegated for bundle mode */
    document.addEventListener('change', function(e) {
      const radio = e.target.closest('input[type="radio"][name^="cps-jersey-version-choice"]');
      if (radio) {
        const card = radio.closest('.cps-addon-expandable');
        if (card && card.dataset.addon === 'jersey-version') {
          const panel = card.closest('.cps-bundle-panel');
          const index = panel ? (parseInt(panel.dataset.bundleIndex, 10) - 1) : 0;
          const state = getState(index);

          state.playerVersionChoice = radio.value;
          state.playerVersionEnabled = card.querySelector('.cps-toggle')?.classList.contains('on') || false;

          updateJerseyBadge(card);

          if (!isBundleMode) {
            syncJerseyVersionChoice();
          }
          refreshDisplayedTotal();
        }
      }
    });

    function buildMainItemForCart() {
      // CRITICAL SAFETY CHECK: Block submission if no valid variant match
      if (!hasValidVariantMatch()) {
        console.error('[Cart] BLOCKED: No matching variant for calculated price');
        if (DEBUG_VARIANT_MATCH) {
          console.log('[DEBUG] BLOCKED at buildMainItemForCart - currentMatchedVariant:', currentMatchedVariant);
          console.log('[DEBUG] lastCalculatedPriceCents:', lastCalculatedPriceCents);
          console.log('[DEBUG] variantLookup keys:', Object.keys(variantLookup));
        }
        alert('Error: No product variant exists for this configuration. Please adjust your selections.');
        return null;
      }

      const mainVariantId = elements.formVariantId ? elements.formVariantId.value : '';
      console.log('[Cart] buildMainItemForCart called. Variant ID:', mainVariantId, 'isBundleMode:', isBundleMode);
      if (!mainVariantId) return null;

      const properties = {};
      const bundleLabel = isBundleMode && bundleList ? (bundleList.dataset.bundleLabel || 'Item') : '';

      if (isBundleMode) {
        const panels = document.querySelectorAll('.cps-bundle-panel');
        console.log('[Cart] Bundle mode, panels found:', panels.length);
        panels.forEach(function (panel, index) {
          const state = getState(index);
          const prefix = bundleLabel + ' ' + (index + 1) + ' - ';
          console.log('[Cart] Panel', index, 'state:', JSON.stringify(state));

          const nnCard = panel.querySelector('[data-addon="name-number"]');
          console.log('[Cart] Panel', index, 'nnCard found:', !!nnCard, 'nameNumber:', state.nameNumber);
          if (nnCard && state.nameNumber) {
            const nameInput = nnCard.querySelector('input[id^="cps-player-name"]');
            const numInput = nnCard.querySelector('input[id^="cps-player-number"]');
            console.log('[Cart] Name input:', nameInput?.value, 'Number input:', numInput?.value);
            if (nameInput && nameInput.value.trim()) {
              properties[prefix + (nnCard.dataset.propName || 'Player Name')] = nameInput.value.trim();
            }
            if (numInput && numInput.value.trim()) {
              properties[prefix + (nnCard.dataset.propNumber || 'Player Number')] = numInput.value.trim();
            }
          }

          const jvCard = panel.querySelector('[data-addon="jersey-version"]');
          if (jvCard && state.playerVersionEnabled) {
            properties[prefix + (jvCard.dataset.propSelection || 'Jersey Version')] = state.playerVersionChoice || 'Player Version Jersey';
          }

          const patchCard = panel.querySelector('[data-addon="worldcup-patch"]');
          if (patchCard && state.patchesEnabled) {
            const select = patchCard.querySelector('select');
            if (select && select.value.trim()) {
              properties[prefix + (patchCard.dataset.propSelection || 'Patch')] = select.value.trim();
            }
          }

          const lsCard = panel.querySelector('[data-addon="long-sleeve"]');
          if (lsCard && state.longSleeve) {
            properties[prefix + (lsCard.dataset.propEnabled || 'Long Sleeve')] = 'Yes';
          }

          // Add size property
          const sizeInput = panel.querySelector('.prop-custom-option-bundle');
          console.log('[Cart] Panel', index, 'sizeInput found:', !!sizeInput, 'value:', sizeInput?.value);
          if (sizeInput && sizeInput.value.trim()) {
            const sizeLabel = sizeInput.name.match(/\[.*-\s*(.*)\]$/)?.[1] || 'Size';
            properties[prefix + sizeLabel] = sizeInput.value.trim();
          }
        });
      } else {
        const state = getState(0);
        console.log('[Cart] Single mode state:', JSON.stringify(state));
        console.log('[Cart] propPlayerName:', propPlayerName?.value, 'propPlayerNumber:', propPlayerNumber?.value);
        console.log('[Cart] propJerseyVersionSelection:', propJerseyVersionSelection?.value);
        console.log('[Cart] propSelectedPatch:', propSelectedPatch?.value);
        console.log('[Cart] propLongSleeve:', propLongSleeve?.value);
        if (state.nameNumber) {
          if (propPlayerName && propPlayerName.value.trim()) properties['Player Name'] = propPlayerName.value.trim();
          if (propPlayerNumber && propPlayerNumber.value.trim()) properties['Player Number'] = propPlayerNumber.value.trim();
        }
        if (state.playerVersionEnabled && propJerseyVersionSelection) {
          properties['Jersey Version'] = propJerseyVersionSelection.value || 'Player Version Jersey';
        }
        if (state.patchesEnabled && propSelectedPatch && propSelectedPatch.value.trim()) {
          properties['Patch'] = propSelectedPatch.value.trim();
        }
        if (state.longSleeve) {
          properties['Long Sleeve'] = 'Yes';
        }
      }

      if (elements.customOptionProp && elements.customOptionProp.value) {
        const propName = elements.customOptionProp.name.match(/\[([^\]]+)\]/)?.[1] || 'Option';
        properties[propName] = elements.customOptionProp.value;
      }

      console.log('[Cart] Final properties:', JSON.stringify(properties));
      return {
        id: Number(mainVariantId),
        quantity: 1,
        properties: properties
      };
    }

    function resetUI() {
      // Reset all addon states to defaults
      addonStates.forEach(function (state, i) {
        addonStates[i] = createDefaultState();
      });

      // Reset all toggle switches
      document.querySelectorAll('.cps-toggle').forEach(function (toggle) {
        toggle.classList.remove('on');
        toggle.setAttribute('aria-checked', 'false');
      });

      // Close all expandable addon cards
      document.querySelectorAll('.cps-addon-expandable').forEach(function (card) {
        card.classList.remove('open');
      });

      // Clear player name/number inputs
      if (playerNameInput) playerNameInput.value = '';
      if (playerNumberInput) playerNumberInput.value = '';

      // Reset patch select to first option
      const patchSelect = document.getElementById('cps-patch-select');
      if (patchSelect) patchSelect.selectedIndex = 0;

      // Reset jersey version radio to Fan Version
      const fanVersionRadio = document.querySelector('input[name="cps-jersey-version-choice"][value="Fan Version Jersey"]');
      if (fanVersionRadio) fanVersionRadio.checked = true;

      // Uncheck all size buttons
      document.querySelectorAll('.cps-size-btn').forEach(function (btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-checked', 'false');
      });

      // Reset hidden form inputs
      if (propNameNumber) propNameNumber.value = 'No';
      if (propNameNumberPrice) propNameNumberPrice.value = '0';
      if (propPlayerName) propPlayerName.value = '';
      if (propPlayerNumber) propPlayerNumber.value = '';
      if (propJerseyVersionEnabled) propJerseyVersionEnabled.value = 'No';
      if (propJerseyVersionSelection) propJerseyVersionSelection.value = 'Fan Version Jersey';
      if (propJerseyVersionPrice) propJerseyVersionPrice.value = '0';
      if (propPatchesEnabled) propPatchesEnabled.value = 'No';
      if (propSelectedPatch) propSelectedPatch.value = '';
      if (propPatchesPrice) propPatchesPrice.value = '0';
      if (propLongSleeve) propLongSleeve.value = 'No';
      if (propLongSleevePrice) propLongSleevePrice.value = '0';
      if (elements.customOptionProp) elements.customOptionProp.value = '';

      // Reset long sleeve card visual state
      if (longSleeveCard) {
        const longSleeveRow = longSleeveCard.querySelector('.cps-option-card-static');
        if (longSleeveRow) longSleeveRow.classList.remove('active');
      }

      // Reset price display to base
      const basePrice = elements.btnPrice ? parseMoneyValue(elements.btnPrice.textContent) : 0;
      // Re-read base from variant or initial display
      const baseValue = parseMoneyValue(currentBasePriceText);
      const formatted = formatMoneyLike(currentBasePriceText, baseValue);
      if (elements.btnPrice) elements.btnPrice.textContent = formatted;
      if (elements.priceNow) elements.priceNow.textContent = formatted;

      // Reset compare at price display
      currentBaseCompareText = '';
      if (elements.btnPriceCompare) elements.btnPriceCompare.style.display = 'none';

      // Reset matched variant to first/default
      currentMatchedVariant = null;
      lastCalculatedPriceCents = 0;
      selectedOptions = { option1: '', option2: '', option3: '' };

      // Reset form variant ID to first available
      if (elements.formVariantId && elements.variantSelect) {
        const firstOption = elements.variantSelect.querySelector('option');
        if (firstOption) {
          elements.formVariantId.value = firstOption.value;
          elements.variantSelect.value = firstOption.value;
        }
      }

      // Clear validation messages
      if (elements.validationMessage) {
        elements.validationMessage.textContent = '';
        elements.validationMessage.classList.remove('visible');
        elements.validationMessage.style.display = 'none';
      }

      // Remove error classes from buttons
      if (elements.addToCartBtn) elements.addToCartBtn.classList.remove('cps-btn-disabled');
      if (elements.buyNowBtn) elements.buyNowBtn.classList.remove('cps-btn-disabled');

      // Remove error class from price
      if (elements.btnPrice) elements.btnPrice.classList.remove('cps-price-error');

      announceToScreenReader('Selections have been reset');
    }

    async function submitMainItem(item, redirectToCheckout) {
      try {
        console.log('[Cart] Sending to /cart/add.js:', JSON.stringify(item));
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(item)
        });

        const responseData = await response.json().catch(() => null);
        console.log('[Cart] Response status:', response.status, 'data:', responseData);

        if (!response.ok) {
          throw new Error('Cart add failed: ' + (responseData?.description || response.status));
        }

        // Reset UI before redirect so back-button returns to clean state
        resetUI();

        announceToScreenReader(redirectToCheckout ? 'Proceeding to checkout' : 'Item added to cart');
        window.location.href = redirectToCheckout ? '/checkout' : '/cart';
      } catch (error) {
        console.error('[Cart] Error:', error);
        announceToScreenReader('Error adding item to cart. Please try again.');
        alert('Could not add selected item: ' + error.message);
      }
    }

    /* ADD TO CART with loading state */
    if (elements.addToCartBtn) {
      elements.addToCartBtn.addEventListener('click', function (e) {
        e.preventDefault();

        if (!validateAddonFields()) {
          return;
        }

        const originalText = elements.addToCartBtn.innerHTML;
        elements.addToCartBtn.disabled = true;
        elements.addToCartBtn.setAttribute('aria-busy', 'true');
        elements.addToCartBtn.innerHTML = 'Adding...';

        const item = buildMainItemForCart();
        if (item) {
          submitMainItem(item, false).finally(() => {
            elements.addToCartBtn.disabled = false;
            elements.addToCartBtn.setAttribute('aria-busy', 'false');
            elements.addToCartBtn.innerHTML = originalText;
          });
        } else {
          elements.addToCartBtn.disabled = false;
          elements.addToCartBtn.setAttribute('aria-busy', 'false');
          elements.addToCartBtn.innerHTML = originalText;
        }
      });
    }

    /* BUY NOW with loading state */
    if (elements.buyNowBtn) {
      elements.buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();

        if (!validateAddonFields()) {
          return;
        }

        const originalText = elements.buyNowBtn.textContent;
        elements.buyNowBtn.disabled = true;
        elements.buyNowBtn.setAttribute('aria-busy', 'true');
        elements.buyNowBtn.textContent = 'Processing...';

        const item = buildMainItemForCart();
        if (item) {
          submitMainItem(item, true).finally(() => {
            elements.buyNowBtn.disabled = false;
            elements.buyNowBtn.setAttribute('aria-busy', 'false');
            elements.buyNowBtn.textContent = originalText;
          });
        } else {
          elements.buyNowBtn.disabled = false;
          elements.buyNowBtn.setAttribute('aria-busy', 'false');
          elements.buyNowBtn.textContent = originalText;
        }
      });
    }

    /* Sync addon states with actual DOM toggle states on page load */
    document.querySelectorAll('.cps-addon-expandable').forEach(function(card) {
      const toggle = card.querySelector('.cps-toggle');
      const addonType = card.dataset.addon;
      if (!toggle || !addonType) return;
      const isOn = toggle.classList.contains('on');

      if (addonType === 'name-number') {
        addonStates[0].nameNumber = isOn;
      } else if (addonType === 'jersey-version') {
        addonStates[0].playerVersionEnabled = isOn;
        const selectedRadio = card.querySelector('input[type="radio"][name^="cps-jersey-version-choice"]:checked');
        if (selectedRadio) {
          addonStates[0].playerVersionChoice = selectedRadio.value;
        }
      } else if (addonType === 'worldcup-patch') {
        addonStates[0].patchesEnabled = isOn;
        const select = card.querySelector('select');
        if (select && select.value) {
          addonStates[0].selectedPatch = select.value;
        }
      }
    });

    /* Initialize long sleeve card active state */
    if (longSleeveCard) {
      const longSleeveRow = longSleeveCard.querySelector('.cps-option-card-static');
      if (longSleeveRow) {
        addonStates[0].longSleeve = longSleeveRow.classList.contains('active');
      }
    }

    /* Initial validation to set correct button states */
    validateAddonFields();
    refreshDisplayedTotal();
  });
})();
